import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BoxIcon } from 'lucide-react';
interface PathCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
  linkLabel?: string;
  href?: string;
  tone?: 'ivory' | 'sage' | 'sand' | 'rose' | 'sky';
  delay?: number;
}
const toneMap: Record<NonNullable<PathCardProps['tone']>, string> = {
  ivory: 'bg-white border-ink-300/15',
  sage: 'bg-sage-100 border-forest-700/10',
  sand: 'bg-sand-100 border-sand-300/40',
  rose: 'bg-[#F7EDE9] border-[#E0BFB3]/40',
  sky: 'bg-[#EDF2F7] border-[#C7D4E0]/40'
};
export function PathCard({
  icon: Icon,
  title,
  description,
  linkLabel,
  href = '#',
  tone = 'ivory',
  delay = 0
}: PathCardProps) {
  const destination = getEnglishPath(href);
  return <motion.a href={destination} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} whileHover={{
    y: -2
  }} className={`group relative flex flex-col gap-4 p-6 md:p-7 rounded-2xl border ${toneMap[tone]} transition-shadow hover:shadow-card`} data-id="element-786" data-mp="2s7exh52rhz6f">
      <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-forest-700/15 text-forest-700" data-id="element-787" data-mp="2zdaq0sobvdk8">
        <Icon size={20} strokeWidth={1.5} data-id="element-788" data-mp="34bc7582712t2" />
      </span>
      <h3 className="font-display text-xl text-ink-900 leading-snug" data-id="element-789" data-mp="39afex09k5n4q">
        {title}
      </h3>
      <p className="text-ink-700 text-[15px] leading-relaxed" data-id="element-790" data-mp="3dcsaivulc4ns">{description}</p>
      {linkLabel && <span className="mt-1 inline-flex items-center gap-1.5 text-forest-700 font-medium text-sm" data-id="element-791" data-mp="3ic56c63fwm2i">
          {linkLabel}
          <ArrowRightIcon size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-0.5" data-id="element-792" data-mp="1izkhn9q6e34s" />
        </span>}
    </motion.a>;
}
function getEnglishPath(path: string) {
  if (!path.startsWith('/') || path.startsWith('/en')) return path;
  return `/en${path}`;
}